import { Avatar as MaterialAvatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import styled from "styled-components";
import { useFetchable } from "../../store/common/fetchable";
import { Users } from "../../store/users/reducer";
import { colours } from "../../styles/colours";

const avatarSize = 4;

const availableColours = [
  "#f94144ff",
  "#f3722cff",
  "#f8961eff",
  "#f9844aff",
  "#f9c74fff",
  "#90be6dff",
  "#43aa8bff",
  "#4d908eff",
  "#577590ff",
  "#277da1ff",
];

const getColour = (initials: string) =>
  availableColours[
    initials.split("").reduce((acc, curr) => curr.charCodeAt(0) + acc, 0) %
      availableColours.length
  ];

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "1.4em",
  },
}));

const Wrapper = styled.div<{ scale: number; golden?: boolean }>`
  width: ${(props) => avatarSize * props.scale}em;
  height: ${(props) => avatarSize * props.scale}em;
  border: ${(props) => props.scale * 2}px solid
    ${(props) => (props.golden ? colours.gold : colours.lightGrey)};
  padding: ${(props) => props.scale * 3}px;
  border-radius: 50%;
  margin-left: 1em;
`;

export const Avatar: React.FunctionComponent<{ scale?: number }> = ({
  scale = 1,
}) => {
  const user = useFetchable(Users.current);
  const classes = useStyles();
  const initials =
    user.status === "ready" && user.data.firstName && user.data.lastName
      ? user.data.firstName[0] + user.data.lastName[0]
      : "JD";

  const isGolden = user.status === "ready" && user.data.believer;

  return (
    <Wrapper scale={scale} golden={isGolden}>
      {
        <MaterialAvatar
          alt="Remy Sharp"
          src="/broken-image.jpg"
          className={classes.root}
          style={{ backgroundColor: getColour(initials) }}
        >
          {initials}
        </MaterialAvatar>
      }
    </Wrapper>
  );
};
